import { Controller } from "@hotwired/stimulus";

export default class CollapsibleSectionController extends Controller {
    static targets = [
        "body",
        "indicator",
        "openClose"
    ];
    static values = { expanded: Boolean };

    readonly bodyTarget!: HTMLElement;
    readonly indicatorTarget!: HTMLElement;
    readonly openCloseTarget!: HTMLElement;
    expandedValue!: boolean;

    toggle() {
        this.expandedValue = !this.expandedValue;
        this.updateDom();
    }

    private updateDom() {
        if (this.expandedValue) {
            $(this.bodyTarget).show('fast');
            $(this.indicatorTarget).removeClass('fa-chevron-right');
            $(this.indicatorTarget).addClass('fa-chevron-down');

            this.openCloseTarget.innerText = "Close";
        }
        else {
            $(this.bodyTarget).hide('fast');
            $(this.indicatorTarget).addClass('fa-chevron-right');
            $(this.indicatorTarget).removeClass('fa-chevron-down');

            this.openCloseTarget.innerText = "Open";
        }
    }
}
